<pop-loading *ngIf="isLoadingGlobal">
</pop-loading>
<p-toast></p-toast>
<router-outlet></router-outlet>

<p-confirmDialog #cd
                 appendTo="body"
                 key="global-confirmation-dialog"
                 styleClass="global-confirmation">
  <p-footer *ngIf="cd.confirmation">
    <button class="confirm-btn"
            *ngIf="cd.confirmation.acceptLabel"
            type="button"
            pButton
            [label]="cd.confirmation.acceptLabel"
            (click)="cd.accept()"></button>
    <button class="reject-btn"
            *ngIf="cd.confirmation.rejectLabel"
            type="button"
            pButton
            [label]="cd.confirmation.rejectLabel"
            (click)="cd.reject()">
    </button>
  </p-footer>
</p-confirmDialog>
